<template>
    <div class="alert alert--danger" v-if="impersonateUser">
      <div class="alert__text">
        You are viewing the app as <strong>{{ impersonateUser.name }}</strong>
      </div>
      <button @click="exitImpersonation()">Exit</button>
    </div>

      <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component" />
      </transition>
    </router-view>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      impersonateUser: 'authentication/impersonateUser',
    })
  },
  methods: {
    exitImpersonation() {
      this.$store.dispatch('authentication/stopImpersonation');
      this.$router.push({ name: 'Affiliates' });
    }
  }
}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .1s
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0
}
</style>
